// @mui
import { Box } from '@mui/material';
//
import { FONT, STAGE } from '../../../theme/stage';
import { CompanyField, placeholder } from '../copy';

// ----------------------------------------------------------------------

type Props = {
  field: CompanyField;
};

export default function Placeholder({ field }: Props) {
  return (
    <Box
      component="span"
      data-placeholder={field}
      sx={{
        fontFamily: FONT.mono,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '.82em',
        letterSpacing: 0,
        color: STAGE.mute,
        px: '.45em',
        py: '.08em',
        border: `1px dashed ${STAGE.lineStrong}`,
        borderRadius: '6px',
        overflowWrap: 'anywhere',
        boxDecorationBreak: 'clone',
        WebkitBoxDecorationBreak: 'clone',
      }}
    >
      {placeholder(field)}
    </Box>
  );
}
